import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { HomeDataResponse, HomePageControllerImpl, HomePageFactoryImpl } from "../../../business";
import { SkeletonHomePage } from "./components";

export function HomePage() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const { userData } = useAuth();
  const [homeData, setHomeData] = useState<HomeDataResponse>();

  const controller = new HomePageControllerImpl();
  const factory = new HomePageFactoryImpl();

  const fetchData = async () => {
    try {
      const response = await controller.onLoad();
      setLoading(false);

      setHomeData(response);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (userData.subscriber === "manager") navigate('/adm/dashboard');
  }, [userData]);

  return isLoading ? <SkeletonHomePage /> : factory.create(homeData);
}